const DNI_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";

const stripPrefix = (value) => {
    const normalized = String(value || "")
        .toUpperCase()
        .replace(/\s|-/g, "");

    if (normalized.startsWith("ES") || normalized.startsWith("PS")) {
        return normalized.slice(2);
    }
    return normalized;
};

export const normalizeDocument = (value) => stripPrefix(value);

export const isValidDni = (value) => {
    const v = normalizeDocument(value);
    if (!/^\d{8}[A-Z]$/.test(v)) return false;
    const number = parseInt(v.slice(0, 8), 10);
    const expectedLetter = DNI_LETTERS[number % 23];
    return v[8] === expectedLetter;
};

export const isValidNie = (value) => {
    const v = normalizeDocument(value);
    if (!/^[XYZ]\d{7}[A-Z]$/.test(v)) return false;

    const prefixMap = { X: "0", Y: "1", Z: "2" };
    const converted = `${prefixMap[v[0]]}${v.slice(1, 8)}`;
    const number = parseInt(converted, 10);
    const expectedLetter = DNI_LETTERS[number % 23];
    return v[8] === expectedLetter;
};

export const isValidCif = (value) => {
    const v = normalizeDocument(value);
    return /^[ABCDEFGHJNPQRSUVW]\d{7}[0-9A-J]$/.test(v);
};

export const isValidPassport = (value) => {
    const v = normalizeDocument(value);
    return /^[A-Z0-9]{6,12}$/.test(v) && /[A-Z]/.test(v) && /\d/.test(v);
};

export const isValidDocument = (value, { allowPassport = true } = {}) => {
    const v = normalizeDocument(value);
    if (!v) return false;

    return (
        isValidDni(v) ||
        isValidNie(v) ||
        isValidCif(v) ||
        (allowPassport && isValidPassport(v))
    );
};

export const normalizePhone = (value) =>
    String(value || "")
        .trim()
        .replace(/[\s().-]/g, "");

export const isValidPhone = (value) => {
    const raw = normalizePhone(value);
    if (!raw) return false;

    const digitsOnly = raw.startsWith("+") ? raw.slice(1) : raw;
    if (!/^\d+$/.test(digitsOnly)) return false;

    return digitsOnly.length >= 9 && digitsOnly.length <= 15;
};

export const normalizeIban = (value) =>
    String(value || "")
        .toUpperCase()
        .replace(/\s+/g, "");

export const isValidIban = (value) => {
    const iban = normalizeIban(value);
    if (!iban) return false;

    if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
    if (iban.length < 15 || iban.length > 34) return false;
    return true;
};
